export const APP_BAR_HEIGHT = 62;

export const ADMIN_PAGE_Y_PADDING = 20;

export const ADMIN_PAGE_Y_OFFSET = APP_BAR_HEIGHT + 2 * ADMIN_PAGE_Y_PADDING;

export const SVG_VIEWBOX_OFFSET = 16;

export const DESKTOP_MENU_WIDTH = 380;